export const chatTitles = {
  ALL: 'ALL',
  ASSIGNED: 'MY INBOX',
  OPEN: 'UNASSIGNED',
  DISMISSED: 'CLOSED',
}